import { combineReducers } from 'redux';
import capture from './capture';
import chargeAndActivateListing from './chargeAndActivateListing';

export default combineReducers({
  capture,
  chargeAndActivateListing,
});
